<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <div class="page-header">
        <div class="row">
          <div class="col">
            <h3 class="page-title">Báo giá nhanh</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item"><a href="/">Dashboard</a></li>
              <li class="breadcrumb-item active">Báo giá nhanh</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title mb-0">Upload & Xử lý báo giá</h4>
            </div>
            <div class="card-body">
              <!-- Metadata -->
              <div class="customer-info-section">
                <h5 class="section-title">Thông tin khách hàng</h5>
                <div class="row g-3">
                  <div class="col-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label class="form-label">Tên công ty</label>
                      <input v-model="meta.customerName" class="form-control" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label class="form-label">Địa chỉ</label>
                      <input v-model="meta.address" class="form-control" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label class="form-label">Điện thoại</label>
                      <input v-model="meta.phone" class="form-control" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label class="form-label">Người liên hệ</label>
                      <input v-model="meta.contactPerson" class="form-control" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label class="form-label">Số tờ</label>
                      <input v-model="meta.soTo" class="form-control" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label class="form-label">Trang</label>
                      <input v-model="meta.trang" class="form-control" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label class="form-label">Người phụ trách</label>
                      <input v-model="meta.nguoiPhuTrach" class="form-control" />
                    </div>
                  </div>
                </div>
              </div>

              <hr class="section-divider" />

              <!-- Upload ảnh -->
              <div class="upload-section">
                <div class="form-group">
                  <label class="form-label">Chọn ảnh báo giá</label>
                  <FileUploader
                    v-model="newFiles"
                    :existing-files="[]"
                    :is-uploading="loading"
                    :multiple="false"
                  />
                </div>
                <div class="action-buttons">
                  <button
                    class="btn btn-success mb-3"
                    :disabled="newFiles.length === 0 || loading"
                    @click="sendToN8N"
                  >
                    <span class="btn-icon">📤</span>
                    <span class="btn-text">Gửi ảnh sang N8N</span>
                  </button>
                </div>

                <!-- Loading -->
                <div v-if="loading" class="loading-indicator">
                  <div class="spinner-border spinner-border-sm me-2" role="status"></div>
                  <span>Đang xử lý ảnh, vui lòng chờ...</span>
                </div>

                <!-- Lỗi -->
                <div v-if="error" class="alert alert-danger mt-2">
                  {{ error }}
                </div>
              </div>

              <!-- Bảng sản phẩm preview -->
              <div v-if="products.length > 0" class="products-section">
                <h5 class="section-title">Danh sách sản phẩm</h5>
                
                <!-- Desktop Table -->
                <div class="table-responsive d-none d-md-block">
                  <table class="table table-bordered table-hover">
                    <thead class="table-light">
                      <tr>
                        <th width="50">STT</th>
                        <th>Tên sản phẩm</th>
                        <th width="120">Xuất xứ</th>
                        <th width="100">Đơn vị</th>
                        <th width="120">Số lượng</th>
                        <th width="150">Đơn giá</th>
                        <th width="150">Thành tiền</th>
                        <th width="120">Ghi chú</th>
                        <th width="80">Xóa</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in products" :key="index">
                        <td class="text-center">{{ index + 1 }}</td>
                        <td>
                          <input v-model="item.tensp" class="form-control form-control-sm" />
                        </td>
                        <td>
                          <input v-model="item.xuatxu" class="form-control form-control-sm" />
                        </td>
                        <td>
                          <input v-model="item.donvi" class="form-control form-control-sm" />
                        </td>
                        <td>
                          <input
                            type="number"
                            v-model.number="item.soluong"
                            class="form-control form-control-sm"
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            v-model.number="item.dongia"
                            class="form-control form-control-sm"
                          />
                        </td>
                        <td class="text-end">
                          {{ formatCurrency((item.soluong || 0) * (item.dongia || 0)) }}
                        </td>
                        <td>
                          <input v-model="item.ghichu" class="form-control form-control-sm" />
                        </td>
                        <td class="text-center">
                          <button
                            type="button"
                            class="btn btn-danger btn-sm btn-remove"
                            @click="removeProduct(index)"
                          >
                            ×
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Mobile Cards -->
                <div class="d-md-none">
                  <div class="product-card" v-for="(item, index) in products" :key="index">
                    <div class="card mb-3">
                      <div class="card-header d-flex justify-content-between align-items-center">
                        <strong>SP {{ index + 1 }}</strong>
                        <button
                          type="button"
                          class="btn btn-danger btn-sm"
                          @click="removeProduct(index)"
                        >
                          ×
                        </button>
                      </div>
                      <div class="card-body">
                        <div class="row g-2">
                          <div class="col-12">
                            <label class="form-label">Tên sản phẩm</label>
                            <input v-model="item.tensp" class="form-control" />
                          </div>
                          <div class="col-6">
                            <label class="form-label">Xuất xứ</label>
                            <input v-model="item.xuatxu" class="form-control" />
                          </div>
                          <div class="col-6">
                            <label class="form-label">Đơn vị</label>
                            <input v-model="item.donvi" class="form-control" />
                          </div>
                          <div class="col-6">
                            <label class="form-label">Số lượng</label>
                            <input
                              type="number"
                              v-model.number="item.soluong"
                              class="form-control"
                            />
                          </div>
                          <div class="col-6">
                            <label class="form-label">Đơn giá</label>
                            <input
                              type="number"
                              v-model.number="item.dongia"
                              class="form-control"
                            />
                          </div>
                          <div class="col-12">
                            <label class="form-label">Thành tiền</label>
                            <input 
                              :value="formatCurrency((item.soluong || 0) * (item.dongia || 0))"
                              class="form-control"
                              readonly
                            />
                          </div>
                          <div class="col-12">
                            <label class="form-label">Ghi chú</label>
                            <input v-model="item.ghichu" class="form-control" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Nút thêm sản phẩm -->
                <div class="action-buttons mb-3">
                  <button class="btn btn-outline-success" @click="addProduct">
                    <span class="btn-icon">+</span>
                    <span class="btn-text">Thêm sản phẩm</span>
                  </button>
                </div>

                <div class="action-buttons text-md-end text-start">
                  <button class="btn btn-primary btn-export" @click="exportExcel">
                    <span class="btn-icon">📊</span>
                    <span class="btn-text">Xuất Excel</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import FileUploader from "@/components/FileUploader.vue";
import { ref } from "vue";

const file = ref(null);
const newFiles = ref([]);
const products = ref([]);
const meta = ref({
  customerName: "",
  address: "",
  phone: "",
  contactPerson: "",
  soTo: "",
  trang: "1",
  nguoiPhuTrach: "",
});
const loading = ref(false);
const error = ref("");

const n8nWebhookUrl = "https://n8n.thepminhtien.com/webhook/nasdklnalsndlkasndasd";
const beExportUrl = process.env.VUE_APP_BASEURL + "/api/export";

async function sendToN8N() {
  if (newFiles.value.length === 0) return;
  loading.value = true;
  error.value = "";

  try {
    const formData = new FormData();
    formData.append("file", newFiles.value[0]);

    const res = await fetch(n8nWebhookUrl, {
      method: "POST",
      body: formData,
    });

    if (!res.ok) throw new Error("N8N trả lỗi!");

    const data = await res.json();
    products.value = data;
    newFiles.value = [];
  } catch (err) {
    console.error(err);
    error.value = "❌ Lỗi khi gửi ảnh sang N8N!";
  } finally {
    loading.value = false;
  }
}

function addProduct() {
  products.value.push({
    tensp: "",
    xuatxu: "",
    donvi: "",
    soluong: 0,
    dongia: 0,
    ghichu: "",
  });
}

function removeProduct(index) {
  products.value.splice(index, 1);
}

async function exportExcel() {
  if (!meta.value.customerName || products.value.length === 0) {
    error.value = "⚠️ Nhập đầy đủ thông tin khách hàng và sản phẩm trước khi xuất!";
    return;
  }

  try {
    const payload = products.value.map((p) => ({
      ...meta.value,
      ...p,
    }));

    const res = await fetch(beExportUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json; charset=utf-8" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) throw new Error("BE trả lỗi!");

    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "baogia.xlsx";
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error(err);
    error.value = "❌ Lỗi khi xuất Excel!";
  }
}

function formatCurrency(value) {
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
  }).format(value);
}
</script>

<style scoped>
.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #2c3e50;
}

.section-divider {
  margin: 1.5rem 0;
}

.form-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.form-group {
  margin-bottom: 1rem;
}

.loading-indicator {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  background: #f8f9fa;
  border-radius: 0.375rem;
  font-size: 0.9rem;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
}

.btn-remove {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.product-card .card-header {
  background: #f8f9fa;
  padding: 0.75rem 1rem;
}

.product-card .form-label {
  font-size: 0.8rem;
  margin-bottom: 0.25rem;
}

.table-responsive {
  border-radius: 0.375rem;
  overflow: hidden;
}

.table th {
  font-weight: 600;
  font-size: 0.85rem;
  white-space: nowrap;
}

.table td {
  vertical-align: middle;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px);
}

.action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.btn-export {
  min-width: 140px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .page-title {
    font-size: 1.25rem;
  }
  
  .card-header h4 {
    font-size: 1.1rem;
  }
  
  .customer-info-section .col-12 {
    margin-bottom: 0.5rem;
  }
  
  .action-buttons {
    justify-content: center;
  }
  
  .action-buttons.text-md-end {
    justify-content: flex-end;
  }
}

@media (max-width: 576px) {
  .page-header {
    padding: 1rem 0;
  }
  
  .breadcrumb {
    font-size: 0.8rem;
  }
  
  .card-body {
    padding: 1rem;
  }
  
  .btn .btn-text {
    display: inline;
  }
  
  .product-card .card-body {
    padding: 0.75rem;
  }
}
.btn-text {
    color: green;
}
</style>